var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatterOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.25C5.0335 0.25 4.25 1.0335 4.25 2V3H2C0.895431 3 0 3.89543 0 5V16C0 16.5523 0.447716 17 1 17H17C17.5523 17 18 16.5523 18 16V5C18 3.89543 17.1046 3 16 3H13.75V2C13.75 1.0335 12.9665 0.25 12 0.25H6ZM12.25 3V2C12.25 1.86193 12.1381 1.75 12 1.75H6C5.86193 1.75 5.75 1.86193 5.75 2V3H12.25ZM2 4.5H16C16.2761 4.5 16.5 4.72386 16.5 5V7H1.5V5C1.5 4.72386 1.72386 4.5 2 4.5ZM1.5 8.5V15.5H16.5V8.5H11.95C11.8395 8.5 11.75 8.58954 11.75 8.7V9C11.75 9.9665 10.9665 10.75 10 10.75H8C7.0335 10.75 6.25 9.9665 6.25 9V8.7C6.25 8.58954 6.16046 8.5 6.05 8.5H1.5ZM7.75 8.5V9C7.75 9.13807 7.86193 9.25 8 9.25H10C10.1381 9.25 10.25 9.13807 10.25 9V8.5H7.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatterOutlined);
export default __webpack_public_path__ + "static/media/matter-outlined.2e0b96e15b9b92d1e82066c27edfff17.svg";
export { ForwardRef as ReactComponent };